"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBSearchBars", {
  enumerable: true,
  get: function get() {
    return _SVBSearchBars.default;
  }
});
var _SVBSearchBars = _interopRequireDefault(require("./src/SVBSearchBars"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }